import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  FETCH_DASHBOARD_DATA_REQUEST,
  FETCH_DASHBOARD_DATA_SUCCESS,
  FETCH_DASHBOARD_DATA_FAILURE,
  FETCH_VENDOR_DASHBOARD_DATA_REQUEST,
  FETCH_CUSTOMER_DASHBOARD_DATA_REQUEST,
} from "./DashboardType";
import {
  fetchDashboardDataSuccess,
  fetchDashboardDataFailure,
  fetchVendorDashboardDataSuccess,
  fetchVendorDashboardDataFailure,
  fetchCustomerDashboardDataSuccess,
} from "./DashboardAction";
import axiosInstance from "../instance/AxiosInstance";
// API function - Updated to accept filters
const fetchDashboardApi = async (filters = {}) => {
  // Build query parameters
  const queryParams = new URLSearchParams();

  // Add date filters (takes precedence over year filters)
  if (filters.fromDate) {
    queryParams.append("fromDate", filters.fromDate);
  }
  if (filters.toDate) {
    queryParams.append("toDate", filters.toDate);
  }

  // Add year filters (only if date filters are not present)
  if (!filters.fromDate && !filters.toDate) {
    if (filters.fromYear) {
      queryParams.append("from_year", filters.fromYear);
    }
    if (filters.toYear) {
      queryParams.append("to_year", filters.toYear);
    }
  }

  // Add service filter
  if (filters.service_ids && filters.service_ids.length > 0) {
    // If multiple services, you might need to handle this differently based on your backend
    // For now, assuming single service_id
    queryParams.append("service_id", filters.service_ids[0]);
  }

  // Add airport filter
  if (filters.airport_ids && filters.airport_ids.length > 0) {
    // If multiple airports, you might need to handle this differently based on your backend
    // For now, assuming single airport_id
    queryParams.append("airport_id", filters.airport_ids[0]);
  }

  const queryString = queryParams.toString();
  const url = `/user/userDashBoard${queryString ? `?${queryString}` : ""}`;

  console.log("Dashboard API URL:", url); // For debugging
  console.log("Filter parameters:", filters); // For debugging

  const response = await axiosInstance.get(url);
  return response.data;
};

const fetchVendorDashboardApi = async () => {
  const response = await axiosInstance.get("/user/vendorDashBoard");
  return response.data;
};

const fetchCustomerDashboardApi = async () => {
  const response = await axiosInstance.get("/user/customerdashboard");
  return response.data;
};

function* fetchDashboardDataSaga(action) {
  try {
    const filters = action.payload || {}; // Get filters from action payload
    const response = yield call(fetchDashboardApi, filters); // Pass filters to API
    yield put(fetchDashboardDataSuccess(response));
  } catch (error) {
    yield put(fetchDashboardDataFailure(error.message));
  }
}

function* fetchVendorDashboardDataSaga() {
  try {
    const data = yield call(fetchVendorDashboardApi);
    yield put(fetchVendorDashboardDataSuccess(data));
  } catch (error) {
    yield put(fetchVendorDashboardDataFailure(error.message));
  }
}

function* fetchCustomerDashboardDataSaga() {
  try {
    const data = yield call(fetchCustomerDashboardApi);
    yield put(fetchCustomerDashboardDataSuccess(data));
  } catch (error) {
    yield put(fetchDashboardDataFailure(error.message));
  }
}

export default function* dashboardSaga() {
  yield takeLatest(FETCH_DASHBOARD_DATA_REQUEST, fetchDashboardDataSaga);
  yield takeLatest(
    FETCH_VENDOR_DASHBOARD_DATA_REQUEST,
    fetchVendorDashboardDataSaga
  );
  yield takeLatest(
    FETCH_CUSTOMER_DASHBOARD_DATA_REQUEST,
    fetchCustomerDashboardDataSaga
  );
}
